import { useEffect } from "react";
import { ReferenceInput, SelectInput, useDataProvider } from "react-admin";
import { useField } from "react-final-form";
import { SchoolIdSelected } from "utils/tools";

interface IWaveInput {
  isDisable?: boolean;
  isEdit?: boolean;
}

const WaveInput = ({ isDisable, isEdit }: IWaveInput) => {
  const routeInput = useField("routeId");
  const studentInput = useField("studentId");
  const busSchedulePlanInput = useField("busSchedulePlanId");
  const waveInput = useField("busScheduleId");

  const provider = useDataProvider();

  useEffect(() => {
    const isBusSchedulePlanIdNotZero =
      Number(busSchedulePlanInput.input.value) !== 0;

    if (isEdit && isBusSchedulePlanIdNotZero) {
      provider
        .getOne("busSchedulePlans", {
          id: Number(busSchedulePlanInput.input.value),
        })
        .then(({ data }) => {
          waveInput.input.onChange(data.busScheduleId);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busSchedulePlanInput]);

  return (
    <>
      {!isEdit ? (
        <ReferenceInput
          label="Select Wave"
          source="busScheduleId"
          reference="busSchedules"
          filter={{ SchoolId: Number(SchoolIdSelected()), HasRoutePlan: true }}
          onChange={() => {
            routeInput.input.onChange("");
            studentInput.input.onChange("");
          }}
          disabled={isDisable}
          perPage={9999}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      ) : (
        <ReferenceInput
          label="Select Wave"
          source="busScheduleId"
          reference="busSchedules"
          disabled={isDisable}
          perPage={9999}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      )}
    </>
  );
};

export default WaveInput;
